var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"my-modal",attrs:{"hide-footer":""}},[_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v("已第"+_vm._s(_vm.viewFileAttempt)+"次为您尝试打开文件")])])])}
var staticRenderFns = []

export { render, staticRenderFns }